import React from 'react'
import './About.css'
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <section id='about'>
      <div className="container-fluid px-md-5 my-5 pt-5 px-3">
        <div className="row">
          <div className="col-md-6 order-2 order-md-1">
            <h6 className='section-title'>{t('about.title')}</h6>
            <h4 className='section-suptitle'>{t('about.subtitle')}</h4>
            <p className='side-desc mb-3'>{t('about.desc')}</p>
            <div className="d-flex gap-3 align-items-center flex-wrap flex-md-nowrap justify-content-center justify-content-md-start">
              <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                <img src="icon-1.png" alt="icon" />
                <p className='icon-desc'>{t('about.icon1')}</p>
              </div>
              <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                <img src="icon-2.png" alt="icon" />
                <p className='icon-desc'>{t('about.icon2')}</p>
              </div>
              <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                <img src="icon-3.png" alt="icon" />
                <p className='icon-desc'>{t('about.icon3')}</p>
              </div>
              <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                <img src="icon-4.png" alt="icon" />
                <p className='icon-desc'>{t('about.icon4')}</p>
              </div>
            </div>
            <div className="d-flex align-items-center gap-3 mt-1">
              <a href="#contact" className="contact-btn rounded-1 py-2 d-flex align-items-center justify-content-center text-decoration-none">{t('nav.contact_us')}</a>
              <a href="#join" className="btn-outline-main rounded-1 py-2 d-flex align-items-center justify-content-center text-decoration-none">{t('hero.partner_btn')}</a>
            </div>
          </div>
          <div className="col-md-6 order-1 order-md-2">
            <img src="about-img.png" className='img-fluid mb-3' alt="about" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
